let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3p02a")).then(() => parcelRequire('lEH8S'));